import styles from './Loading.module.scss';
import React from 'react';
import classNames from 'classnames';

export interface ILoadingProps {
  isLoading: boolean;
  secondary?: boolean;
  children?: React.ReactNode;
  autoHeight?: boolean;
  small?: boolean;
}
const Loading = ({ isLoading, secondary, autoHeight, small, children }: ILoadingProps) => {
  if (isLoading) {
    return (
      <div
        className={classNames(
          styles.spinner_wrapper,
          {
            [styles.spinner_wrapper__secondary]: secondary,
            [styles.spinner_wrapper__auto]: autoHeight,
            [styles.spinner_wrapper__small]: small,
          },
          `d-fl jc-c ai-c`,
        )}
      >
        <div className={styles.spinner}></div>
      </div>
    );
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default Loading;
